// extracted by mini-css-extract-plugin
module.exports = {"tabListItem":"chatListsTab_tabListItem__3Y--t","tabListActive":"chatListsTab_tabListActive__NcOmK"};